module.exports = __webpack_public_path__ + "img/img_bib_logo_bg_left.a1175207.png";